(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4232],{

/***/ 64232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content057": function() { return /* binding */ Content057; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var _Content057_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78376);
/* harmony import */ var _Content057_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Content057_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Content057 = function(param) {
    var payload = param.payload;
    var ref;
    var fullName = (ref = payload === null || payload === void 0 ? void 0 : payload.fullName) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var position = (ref1 = payload === null || payload === void 0 ? void 0 : payload.position) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var photo = (ref2 = payload === null || payload === void 0 ? void 0 : payload.photo) !== null && ref2 !== void 0 ? ref2 : {};
    var ref3;
    var quote = (ref3 = payload === null || payload === void 0 ? void 0 : payload.quote) !== null && ref3 !== void 0 ? ref3 : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_Content057_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wrapper), " ").concat((payload === null || payload === void 0 ? void 0 : payload.format) === "wide" ? (_Content057_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wide) : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Content057_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blockquote),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Blockquote */ .V6, {
                    image: photo,
                    author: fullName,
                    position: position,
                    quote: quote,
                    className: (_Content057_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content)
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content057);


/***/ }),

/***/ 78376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"Content057_content__prPEt","wrapper":"Content057_wrapper__QRejw","wide":"Content057_wide__G2NlN"};

/***/ })

}]);